import React from "react";

export default (props) => 
	<footer className={`footer ${props.className}`} {...props} >
		{props.children}
	</footer>



// WEBPACK FOOTER //
// ./src/components/Footer.js